import {
  ContentLayout,
  ReviewsPillarPageContent,
} from '@silvertours/common-landingpages-view';
import {
  BenefitsLegacy,
  ContentArticle,
  StageLegacy,
} from '@silvertours/front-features';
import { useRawFeatureTranslations } from '@silvertours/front-shared';

import { Body } from '../body';

const ReviewsPillarContent = ({
  content: { article, globalRating, introduction, links, stage },
  ...commonProps
}: ContentLayout<ReviewsPillarPageContent>) => {
  const translations = useRawFeatureTranslations('article');

  return (
    <Body
      variant={{ kind: 'reviewsPillar' }}
      bodyTop={
        <StageLegacy.Stage
          content={stage.content}
          variant={{ kind: 'reviewsPillar' }}
        />
      }
      searchData={stage?.content?.search}
      content={({ containerModule }) => [
        containerModule(
          'usp',
          <BenefitsLegacy.Usp rating={globalRating.content} />,
        ),
        containerModule(
          'introduction-content',
          <ContentArticle
            modules={introduction?.segments ?? []}
            translations={translations}
          />,
          !!introduction?.segments,
        ),
        containerModule(
          'article',
          <ContentArticle
            modules={article.segments}
            translations={translations}
          />,
        ),
        containerModule(
          'linkLists',
          <ContentArticle
            modules={links.content ?? []}
            translations={translations}
          />,
          !!links.content.length,
        ),
      ]}
      {...commonProps}
    />
  );
};
export { ReviewsPillarContent };
